import dynamic from 'next/dynamic';

export const OrderConfirmationPage = dynamic(() => import('./order-confirmation-page'), { ssr: false });
